import React, { useState, useEffect } from "react";
import { List } from "antd";
import UserListItem from "./UserListItem";

const AssignUserList = ({ users = [], onUserSelect, initialSelectedUserId = null }) => {
  const [selectedUserId, setSelectedUserId] = useState(initialSelectedUserId);

  // Update selectedUserId when initialSelectedUserId changes
  useEffect(() => {
    setSelectedUserId(initialSelectedUserId);
  }, [initialSelectedUserId]);

  const handleUserSelect = userId => {
    setSelectedUserId(userId);
    const selectedUser = users.find(user => user.id === userId);
    if (onUserSelect) {
      onUserSelect(selectedUser);
    }
  };

  return (
    <div>
      {/* Users List */}
      <List
        dataSource={users}
        renderItem={user => (
          <List.Item className="!p-0 !border-0 !w-full">
            <div className="w-full">
              <UserListItem
                user={user}
                selected={selectedUserId === user.id}
                onSelect={handleUserSelect}
              />
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default AssignUserList;
